




























































import { Meta } from "@/store/meta"
import { Vue, Component, Prop } from "vue-property-decorator"
import { Server } from '@/store/server'
import { getModule } from "vuex-module-decorators"
@Component({
})
export default class Contact extends Vue {
  get meta() {
    return getModule(Meta)
  }
  get server() {
    return getModule(Server)
  }
}
